import type { AnalyticsPayloadSchema } from "@Common/types/bo/analytics_public/analytics_public";
import { IntroTitle } from "@Src/constants";
import { sendEncryptedData } from "@Src/utils/encryption";
import {
	Box,
	Button,
	List,
	ListItem,
	ListItemText,
	Paper,
	Typography,
} from "@mui/material";
import { type ReactNode, useState } from "react";
import type { DataProvider } from "react-admin";

interface IntroWrapperProps {
	/** The content to render after Next is clicked */
	children: ReactNode;
	dataProvider: DataProvider;
	recordId: string | null;
	publicKey: string | null;
}

export const ShowIntro = ({
	children,
	dataProvider,
	recordId,
	publicKey,
}: IntroWrapperProps) => {
	const [started, setStarted] = useState(false);

	const handleNext = () => {
		setStarted(true);
		if (recordId && publicKey) {
			const payload: AnalyticsPayloadSchema = {
				type: "show_intro_success",
				application_public_id: recordId,
			};
			sendEncryptedData(
				dataProvider,
				"analytics_public",
				recordId,
				payload,
				publicKey,
			).catch(() => {});
		}
	};

	if (started) {
		return <Box>{children}</Box>;
	}

	return (
		<Box
			sx={{
				height: "100vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				backgroundColor: "#fafafa",
				p: 2,
			}}
		>
			<Paper
				elevation={3}
				sx={{
					p: 4,
					maxWidth: 650,
					textAlign: "left",
					borderRadius: 3,
				}}
			>
				<Typography variant="h4" gutterBottom textAlign="center">
					{IntroTitle}
				</Typography>

				<Box sx={{ mb: 3 }}>
					<List dense>
						<ListItem>
							<ListItemText primary="Nomachine requires answering the form in one go." />
						</ListItem>
						<ListItem>
							<ListItemText primary="You must not leave the browser tab." />
						</ListItem>
						<ListItem>
							<ListItemText primary="If the form is timed, you will see a timer and your responses will automatically submit at the end of the countdown." />
						</ListItem>
					</List>
				</Box>

				<Box textAlign="center">
					<Button
						variant="contained"
						color="primary"
						size="large"
						onClick={handleNext}
					>
						Next
					</Button>
				</Box>
			</Paper>
		</Box>
	);
};
